export const ServiceExecutionStatus = Object.freeze({
  PENDING: "PENDING",
  NOTIFICATION: "NOTIFICATION",
  FINISHED: "FINISHED",
});
